import axios from 'axios-jsonp-pro';
import qs from 'qs';
import { Message } from 'element-ui'
import router from '@/router'


// 拦截器封装（token验证）
axios.interceptors.request.use(config => {

  if (config.url.indexOf('/api/auth/login') === -1) {
    config.headers.Authorization = localStorage.getItem('xAuthToken')
  }
  return config;
})


// ajax GET
let get = (url, data, headers) => {

  let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''
  url = `${prefix}${url}?_v=${Date.now()}`

  // get参数组装
  let StrP = ''
  if (data) {
    for (let i in data) {
      if (data[i] || data[i] === 0) StrP = StrP + '&' + i + '=' + encodeURIComponent(data[i])
    }
  }


  return axios({
    url: url + StrP,
    method: 'get',
    headers: headers || null
  }).then(res => {
    if (res.headers['x-auth-token']) {
      localStorage.setItem('xAuthToken', res.headers['x-auth-token'])
    }

    if (res.data.code !== 200) {
      if (res.data.code === 1001) {
        router.push({ path: '/login' })
      } else {
        if(res.data.message)
        Message(res.data.message)
      }
    }

    return res.data
  }).catch(error => {
    if(error.response.data.message)
    Message(error.response.data.message)
  })
}


// ajax POST
let post = (url, data, headers, ifFomrData) => {

  let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''

  url = `${prefix}${url}?_v=${Date.now()}`

  // 剔除空参数
  let _data = {};


  if (!ifFomrData) {
    for (let i in data) {
      if (data[i] || data[i] === 0) {
        _data[i] = data[i]
      }
    }
  }


  let params = headers && (headers['Content-Type'] === 'application/json' || headers['Content-Type'] === 'multipart/form-data') ? data : qs.stringify(_data)

  return axios({
    url: url,
    data: params,
    method: 'post',
    headers: headers || null
  }).then(res => {
    console.log(res);
    if (res.headers['x-auth-token']) {
      localStorage.setItem('xAuthToken', res.headers['x-auth-token'])
    }

    if (res.data.code !== 200) {
      if (res.data.code === 1001) {
        router.push({ path: '/login' })
      } else {
        console.log('aaa');
        Message(res.data.message)
      }
    }

    return res.data
  }).catch(error => {
    Message(error.response.data.message)
  })
}

// ajax POST
let put = (url, data, headers) => {

  let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''

  url = `${prefix}${url}?_v=${Date.now()}`

  // 剔除空参数
  let _data = {}
  console.log(data);
  for (let i in data) {
    if (data[i] || data[i] === 0) {
      _data[i] = data[i]
    }
  }

  let params = headers && headers['Content-Type'] === 'application/json' ? _data : qs.stringify(_data)

  return axios({
    url: url,
    data: params,
    dataType: 'json',
    method: 'put',
    headers: headers || null
  }).then(res => {
    if (res.headers['x-auth-token']) {
      localStorage.setItem('xAuthToken', res.headers['x-auth-token'])
    }

    if (res.data.code !== 200) {
      if (res.data.code === 1001) {
        router.push({ path: '/login' })
      } else {

        Message(res.data.message)
      }
    }

    return res.data
  }).catch(error => {
    Message(error.response.data.message)
  })
}
// ajax delete
let _delete = (url, data, headers) => {

  let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''
  url = `${prefix}${url}?_v=${Date.now()}`

  // get参数组装
  let StrP = ''
  if (data) {
    for (let i in data) {
      if (data[i] || data[i] === 0) StrP = StrP + '&' + i + '=' + data[i]
    }
  }

  return axios({
    url: url + StrP,
    method: 'delete',
    headers: headers || null
  }).then(res => {
    if (res.headers['x-auth-token']) {
      localStorage.setItem('xAuthToken', res.headers['x-auth-token'])
    }

    if (res.data.code !== 200) {
      if (res.data.code === 1001) {
        router.push({ path: '/login' })
      } else {
        Message(res.data.message)
      }
    }

    return res.data
  }).catch(error => {
    Message(error.response.data.message)
  })
}


export default {
  get,

  login: (data) => post('/api/auth/login', data),

  // 获取订单列表
  getOrderList: (data) => get('/api/hjx/order', data),

  //批量导入质检报告
  importBatchQuality: (data) => post('/api/hjx/quality/batchQuality', data, { 'Content-Type': 'multipart/form-data' }),

    //导入质检报告
  importHjxQualityTemplete: (data) => post('/api/hjx/qualityInfo/importHjxQualityTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //查看质检报告
  queryQualityInfo: (orderNO, data) => post(`/api/hjx/qualityInfo/getInfo/${orderNO}`, data),

  // 获取商户列表
  getMerchantList: (data) => get('/api/hjx/merchant', data),

  // 添加商户
  addMerchant: (data) => post('/api/hjx/merchant', data, {
    'Content-Type': 'multipart/form-data'
  }),

  // 导入用户
  importUser: (data) => post('/api/sys/user/importUser', data, {
    'Content-Type': 'multipart/form-data'
  }),
  // 导入门店
  importStore: (data) => post('/api/hjx/store/importStore', data, {
    'Content-Type': 'multipart/form-data'
  }),

  // 导入门店
  importSendInfo: (data) => post('/api/hjx/order/importSendInfo', data, {
    'Content-Type': 'multipart/form-data'
  }),

  //获取店员信息集合
  getClerkListSearch: (data) => post('/api/sys/user/clerkListSearch', data),

  // 修改商户信息
  changeMerchant: (id, data) => post('/api/hjx/merchant/' + id, data, {
    'Content-Type': 'multipart/form-data'
  }),

  // 启用商户
  openMerchant: (id, data) => post(`/api/hjx/merchant/${id}/enable`, data),

  // 禁用商户
  closeMerchant: (id, data) => post(`/api/hjx/merchant/${id}/disable`, data),


  // 获取商户详情
  getMerchantDetail: (id) => get('/api/hjx/merchant/' + id),


  // 获取区域列表
  getCityAreaList: (data) => get('/api/hjx/user-area', data),

  // 删除区域
  deleteCity: (data) => _delete('/api/hjx/user-area/deleteArea', data),



  // 获取商户列表
  getUserList: (data) => get('/api/sys/user', data),

  // 获取导航
  getMenuList: (data) => get('/api/sys/menu', data),

  // 类型管理
  getLinkage: (data) => get('/api/sys/linkage', data),

  // 类型管理(树形)
  getLinkageTree: (data) => get('/api/sys/linkage/tree', data),

  // 类型管理
  getClass: (data) => get('/api/hjx/category', data),

  // 类型添加
  addLinkage: (data) => post('/api/sys/linkage', data),

  // 类型修改
  changeLinkage: (id, data) => put(`/api/sys/linkage/${id}`, data),

  // 类型修改
  changeLinkageOrder: (data) => post('/api/sys/linkage/swap', data),

  // 类型管理
  getOrderTag: (data) => get('/api/hjx/category', data),

  // 选项值
  getSelectOptionValueList: (data) => get('/api/hjx/category/selectOptionValueList', data),

  // 评估项目
  getValuationOptionList: (data) => get('/api/hjx/category/valuationOptionList', data),

  // 成色和功能选项值
  getSelectFuncationAndConditionOptionValueList: (data) => get('/api/hjx/category/selectFuncationAndConditionOptionValueList', data),


  // 新增用户
  addUser: (data) => post('/api/sys/user', data),

  // 修改用户
  changeUser: (data) => put('/api/sys/user/' + data.id, data),

  // 启用账号
  openUser: (id, data) => post(`/api/sys/user/${id}/enable`, data),

  // 禁用账号
  closeUser: (id, data) => post(`/api/sys/user/${id}/disable`, data),

  // 取消订单
  cancleOrder: (data) => post('/api/hjx/order/' + data.orderNo + '/cancel', data),

  // 修改订单状态订单
  changeOrder: (data) => post('/api/hjx/order/' + data.orderNo + '/cancel', data),

  // 上传文件
  uploadImage: (data) => post('/api/upload/aliyun', data, {
    'Content-Type': 'multipart/form-data'
  }),

  // 上传文件
  uploadImageFull: (data) => post('/api/upload/aliyunFull', data, {
    'Content-Type': 'multipart/form-data'
  }),

  // 订单导出数据
  getExportOrderData: (data) => get('/api/hjx/order/export', data),


  // // 订单导出数据
  // getExportOrderData: (data) => get('/api/hjx/order/export', data),

  // 门店列表
  getStoreList: (data) => get('/api/hjx/store', data),

  //根据商户ID，获取门店列表
  getStoreListByMerchantId: (data) => get('/api/hjx/store/listByMerchantId', data),

  // 添加门店
  addStore: (data) => post('/api/hjx/store', data),

  // 开启门店
  openStore: (id) => post(`/api/hjx/store/${id}/enable`),

  // 关闭门店
  closeStore: (id) => post(`/api/hjx/store/${id}/disable`),

  // 修改门店
  changeStore: (id, data) => put(`/api/hjx/store/${id}`, data),


  // 获取角色列表
  getRoleList: (id, data) => get('/api/sys/role', data),

  // 修改订单状态
  updateOrderStatus: (data) => post('/api/hjx/order/updateOrderStatus', data),
  newExportTask: (data) => post('/api/hjx/export/add', data),
  getExportTaskList: (data) => post('/api/hjx/export/list', data),

  // 获取模块列表
  getModuleList: (data) => get('/api/hjx/module', data),

  changeModuleMerchant: (id, data) => post(`/api/hjx/module/${id}`, data),

  enableModule: (id) => post(`/api/hjx/module/${id}/enable`),

  disableModule: (id) => post(`/api/hjx/module/${id}/disable`),

  // SKU管理
  listSearch: (data) => post('/api/hjx/sku/listSearch', data),

  swap: (data) => post('/api/hjx/sku/swap', data),

  updateSKu: (data) => post('/api/hjx/sku/updateSKu', data),

  skuTree: (data) => post('/api/hjx/sku/skuTree', data),

  phoneBrand: (data) => post('/api/hjx/sku/phoneBrand', data),

  getValidSku: (data) => post('/api/hjx/sku/getValidSku', data),

  //自动报价设置接口
  quoteConfigList: (data) => post('/api/hjx/quoteConfig/systemQuoteTime', data),

  updateSystemQuoteTime: (data) => post('/api/hjx/quoteConfig/updateSystemQuoteTime', data),

  quoteConfigPage: (data) => post('/api/hjx/quoteConfig/page', data),

  updateQuoteConfig: (data) => post('/api/hjx/quoteConfig/update', data),

  deleteQuoteConfig: (data) => post('/api/hjx/quoteConfig/delete', data),

  saveQuoteConfig: (data) => post('/api/hjx/quoteConfig/add', data),


  //系统配置接口
  getSystemSetting:(key)=>get(`/api/hjx/system/setting/${key}`),
  saveSystemSetting:(data)=>post('/api/hjx/system/setting/save',data),

  //等级
  gradeListSearch: (data) => post('/api/hjx/grade/listSearch', data),

  gradeSwap: (data) => post('/api/hjx/grade/swap', data),

  gradeUpdateGrade: (data) => post('/api/hjx/grade/updateGrade', data, { 'Content-Type': 'application/json' }),

  gradeFunctionConditionValues: (data) => post('/api/hjx/grade/functionConditionValues', data),

  getValidModelGrade: (data) => post('/api/hjx/grade/getValidModelGrade', data),



  //模板相关接口
  getTemplateValue: (data) => post('/api/hjx/evaluationTemplate/getTemplateValue', data),

  listEvaluationTemplate: (data) => post('/api/hjx/evaluationTemplate/listEvaluationTemplate', data),

  getTemplateValueByBrand: (data) => post('/api/hjx/evaluationTemplate/getTemplateValueByBrand', data),

  listEvaluationTemp: (data) => post('/api/hjx/evaluationTemplate/listEvaluationTemp', data),

  templateListSearch: (data) => post('/api/hjx/evaluationTemplate/listSearch', data),

  evaluationTemplateSwap: (data) => post('/api/hjx/evaluationTemplate/swap', data),

  updateEvaluationTemplate: (data) => post('/api/hjx/evaluationTemplate/updateEvaluationTemplate', data, { 'Content-Type': 'application/json' }),

  //基准定价接口
  modelPriceListSearch: (data) => post('/api/hjx/modelPrice/listSearch', data),

  //基准定价接口
  modelPriceById: (data) => get('/api/hjx/modelPrice/getById', data),

  //基准定价接口
  modelPriceListOther: (data) => post('/api/hjx/modelPrice/listOtherGrade', data),

  updateModelPrice: (data) => post('/api/hjx/modelPrice/updateModelPrice', data),

  //等级扣款项
  modelPriceDeductionListSearch: (data) => post('/api/hjx/modelPriceDeduction/listSearch', data),

  updateModelPriceDeduction: (data) => post('/api/hjx/modelPriceDeduction/updateModelPriceDeduction', data),

  //价格段利润设置
  modelProfitListSearch: (data) => post('/api/hjx/modelProfit/listSearch', data),

  updateModelProfit: (data) => post('/api/hjx/modelProfit/updateModelProfit', data),

  imporModelPriceTemplete: (data) => post('/api/hjx/modelPrice/imporModelPriceTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //店员利润扣款设置
  employeeProfitListSearch: (data) => post('/api/hjx/employeeProfit/listSearch', data),

  updateEmployeeProfit: (data) => post('/api/hjx/employeeProfit/updateEmployeeProfit', data),

  imporModelPriceDeductionTemplete: (data) => post('/api/hjx/modelPriceDeduction/imporModelPriceDeductionTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //机型评估
  getEvaluation: (data) => post('/api/hjx/evaluation/getEvaluation', data),

  getEvalTemplateValueByBrand: (data) => post('/api/hjx/evaluation/getTemplateValueByBrand', data),

  evaluationListSearch: (data) => post('/api/hjx/evaluation/listSearch', data),

  evaluationSwap: (data) => post('/api/hjx/evaluation/swap', data),

  updateEvaluation: (data) => post('/api/hjx/evaluation/updateEvaluation', data, { 'Content-Type': 'application/json' }),

  queryEvaluationParam: (data) => post('/api/hjx/evaluation/queryParam', data),
  //价格查询
  priceQueryParam: (data) => post('/api/hjx/model/priceQueryParam', data),

  priceQuery: (data) => post('/api/hjx/model/priceQuery', data, { 'Content-Type': 'application/json' }),

  //回收商管理
  getValidHjxServiceProvider: (data) => post('/api/hjx/serviceProvider/getValidHjxServiceProvider', data),

  listQuoteSearch: (data) => post('/api/hjx/serviceProvider/listQuoteSearch', data),

  serviceProviderListSearch: (data) => post('/api/hjx/serviceProvider/listSearch', data),

  updateQuoteUser: (data) => post('/api/hjx/serviceProvider/updateQuoteUser', data),

  updateServiceProvider: (data) => post('/api/hjx/serviceProvider/updateServiceProvider', data),

  //钱包
  walletListSearch: (data) => post('/api/business/wallet/listSearch', data),
  enableWallet: (data) => post('/api/business/wallet/enableWallet', data),
  listWalletDetail: (data) => get('/api/business/wallet/listWalletDetail', data),
  processBalanceAdmin: (data) => post('/api/business/wallet/processBalanceAdmin', data),

  //选项管理导入导出
  getEvaluationValueTemplete: (data) => get('/api/sys/linkage/getEvaluationValueTemplete', data),

  imporEvaluationValueTemplete: (data) => post('/api/sys/linkage/imporEvaluationValueTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //评估项目导入导出
  getEvaluationItemsTemplete: (data) => get('/api/sys/linkage/getEvaluationItemsTemplete', data),

  imporEvaluationItemsTemplete: (data) => post('/api/sys/linkage/imporEvaluationItemsTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //sku导入模板
  imporSkuTemplete: (data) => post('/api/hjx/sku/imporSkuTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //sku管理导入模板
  imporHjxSkuTemplete: (data) => post('/api/hjx/sku/imporHjxSkuTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //发送验证码
  sendSms: (data) => post('/api/auth/sendSms', data),

  //佣金红包管理
  commissionListSearch: (data) => post('/api/hjx/commission/listSearch', data),

  updateCommission: (data) => post('/api/hjx/commission/updateCommission', data),

  //获取有效商户列表
  getValidMerchant: (data) => post('/api/hjx/merchant/getValidMerchant', data),

  //销售数据
  getSaleOrderListSearch: (data) => post('/api/hjx/saleOrder/listSearch', data),

  imporSaleOrderTemplete: (data) => post('/api/hjx/saleOrder/imporSaleOrderTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //删除订单
  deleteOrder: (data) => post('/api/hjx/order/deleteOrder', data),

  //删除用户
  deleteUser: (data) => post('/api/sys/user/deleteUser', data),

  //删除销售订单
  deleteSaleOrder: (data) => post('/api/hjx/saleOrder/deleteSaleOrder', data),

  //删除门店
  deleteStore: (data) => post('/api/hjx/store/delete', data),

  //删除回收商
  deleteServiceProvider: (data) => post('/api/hjx/serviceProvider/delete', data),

  //删除基准定价
  deleteBasePrice: (data) => post('/api/hjx/modelPrice/delete', data),

  //删除等级
  deleteGrade: (data) => post('/api/hjx/grade/delete', data),

  //删除机型等级扣款项
  deleteLevelPriceDeduction: (data) => post('/api/hjx/modelPriceDeduction/delete', data),

  //删除价格段利润
  deletePriceCost: (data) => post('/api/hjx/modelProfit/delete', data),

  //删除店员价格差利润
  deleteProfitCost: (data) => post('/api/hjx/employeeProfit/delete', data),

  //删除机型评估
  deleteEvaluation: (data) => post('/api/hjx/evaluation/delete', data),

  //删除模板
  deleteEvaluationTemplate: (data) => post('/api/hjx/evaluationTemplate/delete', data),

  //删除类别值
  deleteLinkage: (data) => post('/api/sys/linkage/delete', data),

  //删除SKU
  deleteSku: (data) => post('/api/hjx/sku/delete', data),

  //删除商户
  deleteMerchant: (data) => post('/api/hjx/merchant/delete', data),

  //删除佣金红包
  deleteCommission: (data) => post('/api/hjx/commission/delete', data),

  //获取指定回收商下的报价员
  getQuoteUserByServiceIds: (data) => post('/api/sys/user/getQuoteUserByServiceIds', data),

  //换机侠寄卖-订单
  getConsignmentOrderList: (data) => post('/consignment/order/list', data),
  updateOrder: (data) => post('/consignment/order/update', data),

  getConsignmentOrderInfo: (data) => post('/consignment/order/info', data),


  //换机侠寄卖-物品
  getConsignmentItemList: (data) => post('/consignment/order/item/list', data),

  getItemListByOrderCode: (data) => post('/consignment/order/item/listByOrderCode', data),

  getItemInfo: (data) => post('/consignment/order/item/info', data),

  getItemChaffer: (data) => post('/consignment/order/item/chaffer', data),

  confirmReturnGoods: (data) => post('/consignment/order/item/confirmReturnGoods', data),

  confirmPay: (data) => post('/consignment/order/item/confirmPay', data),


  //换机侠寄卖-质检
  getConsignmentQualityList: (data) => post('/consignment/qualityInfo/list', data),

  //换机侠寄卖-议价
  getConsignmentChafferList: (data) => post('/consignment/chafferInfo/list', data),

  getChafferItemMappingList: (data) => post('/consignment/chafferItemMapping/list', data),

  //换机侠寄卖-退货
  getConsignmentReturnGoodsList: (data) => post('/consignment/returnGoodsInfo/list', data),

  getReturnGoodsItemMappingList: (data) => post('/consignment/returnGoodsItemMapping/list', data),

  //换机侠寄卖-结算
  getConsignmentSettlementList: (data) => post('/consignment/settlementInfo/list', data),

  getSettlementItemMappingList: (data) => post('/consignment/settlementItemMapping/list', data),

  //换机侠寄卖-回收商
  getConsignmentRecyclerList: (data) => post('/consignment/recyclerInfo/list', data),

  //获取评估选项
  getEvaluationOptions: (data) => post('/api/hjx/evaluationTemplate/getEvaluationOptions', data),

   //获取用户地址
   getAddressByUserId: (data) => get('/api/hjx/address', data),

  //获取用户收款账号
  getPayInfoByUserId: (data) => post('/consignment/payInfo/list', data),

  //获取有效城市经理
  getCityManager: (data) => post('/api/sys/user/getCityManager', data),

  //回收商更换城市经理
  recyclerInfoUpdate: (data) => post('/consignment/recyclerInfo/update', data),

  //导入质检报告
  importQualityTemplete: (data) => post('/consignment/qualityInfo/importQualityTemplete', data, { 'Content-Type': 'multipart/form-data' }),

  //修改平台信息接口
  updatePlatInfo: (data) => post('/consignment/jmPlatInfo/update', data),

  getPlatInfo: (data) => post('/consignment/jmPlatInfo/list', data),

  getData:(data) =>get('/api/hjx/order/orderStat', data),

  getMymerchant:(data) =>get('/api/hjx/merchant/my', data),

  refresh:(data) =>post('/api/hjx/evaluation/refresh', data),

 // 订单商户统计
  getIndex:(data) =>get('/api/hjx/dataStat/index', data),

  // 回收商统计
  getOrderServiceStat:(data) =>get('/api/hjx/dataStat/orderServiceStat', data),

  // 回收商统计导出
  getOrderServiceStatExport:(data) =>get('/api/hjx/dataStat/orderServiceStatExport', data),

  // 订单门店统计
  getOrderStoreStat:(data) =>get('/api/hjx/dataStat/orderStoreStat', data),

  // 订单门店统计
  getOrderStoreStatExport:(data) =>get('/api/hjx/dataStat/orderStoreStatExport', data),

   // 搜索页面获取对应的类型和品牌信息
   getLinkagePhoneModel:(data) =>get('/api/sys/linkage/phoneModel', data),


  // 获取价格查询的信息
  getPriceQueryParamSearchPriceH5:(data) =>post('/api/hjx/searchPriceH5/priceQueryParam', data),

   // 创建开放应用
  createOpenApp:(data) =>post('/api/open/manage/create', data),

  priceQuerySearchPriceH5:(data) => post('/api/hjx/searchPriceH5/priceQuery', data, { 'Content-Type': 'application/json' }),
  // 获取价格查询的信息
  checkChannelId:(data) =>post('/api/hjx/searchPriceH5/checkChannelId', data),
  // 类型管理
  getSearchPriceH5Class:(data) => get('/api/hjx/searchPriceH5/category', data),

    // 更新开放应用
  updateOpenApp:(data) =>post('/api/open/manage/update', data),

  // 获取开放应用
  listOpenApp:(data) =>get('/api/open/manage/list', data),

 // 获取开放应用
  getOpenApp:(data) =>get('/api/open/manage/get', data),

  getOrderDetail:(data) => get('/api/hjx/order/currentAdmin/' + data.orderNo , data),

    // 获取质检订单搜索信息
    getQualitySearch: (data) => get('/api/hjx/quality/search', data),

  // 生产充值链接
  getRechargePrice:(data) =>post('/api/dxt/rechargePrice', data),

  qualityCommit:(data) => post('/api/hjx/quality/commit', data, { 'Content-Type': 'application/json' }),

  // 查询迪信通回收资金
  getRecycleFund:(data) =>post('/api/dxt/recycleFund', data),

   // 查询迪信通物流资金
  getExpressBalance:(data) =>post('/api/dxt/expressBalance', data),

  // 充值迪信通物流资金
  getExpressRechargePrice:(data) =>post('/api/dxt/expressRechargePrice', data,{ 'Content-Type': 'application/json' }),

  // 添加自动出价等级规则
  addAutoPriceGradeConfig: (data) => post('/api/hjx/autoPriceGradeConfig/add', data,{ 'Content-Type': 'application/json' }),
  // 修改自动出价等级规则
  updateAutoPriceGradeConfig: (data) => post('/api/hjx/autoPriceGradeConfig/update', data, { 'Content-Type': 'application/json' }),
  // 获取自动出价等级规则
  getAutoPriceGradeConfig: (id) => get(`/api/hjx/autoPriceGradeConfig/${id}`),
  // 自动出价等级规则list
  listSearchAutoPriceGradeConfig: (data) => post(`/api/hjx/autoPriceGradeConfig/page`,data, { 'Content-Type': 'application/json' }),
  // 删除自动出价等级规则
  deleteAutoPriceGradeConfig: (data) => post('/api/hjx/autoPriceGradeConfig/delete',data),
    // 开启自动出价
    openAutoPriceGradeConfig: (id) => post(`/api/hjx/autoPriceGradeConfig/${id}/enable`),
    // 关闭自动出价
    closeAutoPriceGradeConfig: (id) => post(`/api/hjx/autoPriceGradeConfig/${id}/disable`),

    // 忽略机型
    ignoreTailiModel: (data) => post('/api/hjx/tailiNewModelMapping/ignore', data, { 'Content-Type': 'application/json' }),
  
    // 绑定太力机型
  bindTailiModel: (data) => post('/api/hjx/tailiNewModelMapping/bind', data, { 'Content-Type': 'application/json' }),
   // 机型列表
  listSearchNewModelMapping: (data) => post(`/api/hjx/tailiNewModelMapping/page`,data, { 'Content-Type': 'application/json' }),
  
   // 添加支付配置规则
   addAlipyAccount: (data) => post('/api/hjx/alipyAccount/add', data,{ 'Content-Type': 'application/json' }),
   // 修改支付配置规则
   updateAlipyAccount: (data) => post('/api/hjx/alipyAccount/update', data, { 'Content-Type': 'application/json' }),
   // 获取支付配置规则
   getAlipyAccount: (id) => get(`/api/hjx/alipyAccount/${id}`),
   // 支付配置规则list
   listSearchAlipyAccount: (data) => post(`/api/hjx/alipyAccount/page`,data, { 'Content-Type': 'application/json' }),
   // 删除支付配置规则
   deleteAlipyAccount: (data) => post('/api/hjx/alipyAccount/delete',data),
     // 开启支付配置
     openAlipyAccount: (id) => post(`/api/hjx/alipyAccount/${id}/enable`),
     // 关闭支付配置
     closeAlipyAccount: (id) => post(`/api/hjx/alipyAccount/${id}/disable`),
      // 支付测试
      payTest: (id) => post(`/api/hjx/alipyAccount/payTest/${id}`),
      // 切换测试
      switchPayTest: (id) => post(`/api/hjx/alipyAccount/switchPayTest`),

    // 支付配置规则list
    listSearchPayOrder: (data) => post(`/api/hjx/payOrder/page`,data, { 'Content-Type': 'application/json' }),
    // 推送订单
    pushPayOrder: (id) => post(`/api/hjx/payOrder/${id}/push`),
    // 推送订单
    paySuccessAndPush: (id) => post(`/api/hjx/payOrder/${id}/paySuccessAndPush`),
    // 推送订单
    waitPay: (id) => post(`/api/hjx/payOrder/${id}/waitPay`),


  // 添加订单筛选规则
  addOrderFilterConfig: (data) => post('/api/hjx/orderFilterConfig/add', data,{ 'Content-Type': 'application/json' }),
  // 修改订单筛选规则
  updateOrderFilterConfig: (data) => post('/api/hjx/orderFilterConfig/update', data, { 'Content-Type': 'application/json' }),
  // 获取订单筛选规则
  getOrderFilterConfig: (id) => get(`/api/hjx/orderFilterConfig/${id}`),
  // 订单筛选规则list
  listSearchOrderFilterConfig: (data) => post(`/api/hjx/orderFilterConfig/page`,data, { 'Content-Type': 'application/json' }),
  // 删除订单筛选
  deleteOrderFilterConfig: (data) => post('/api/hjx/orderFilterConfig/delete',data),
  // 开启订单筛选
  openOrderFilterConfig: (id) => post(`/api/hjx/orderFilterConfig/${id}/enable`),
  // 关闭订单筛选
  closeOrderFilterConfig: (id) => post(`/api/hjx/orderFilterConfig/${id}/disable`),



  // 修改后付费订单设置
  updateOrderAfterPayConfig: (data) => post('/api/hjx/orderAfterPayConfig/update', data, { 'Content-Type': 'application/json' }),
  // 后付费订单设置规则list
  listSearchOrderAfterPayConfig: (data) => post(`/api/hjx/orderAfterPayConfig/page`,data, { 'Content-Type': 'application/json' }),
 // 开启后付费订单设置
  openOrderAfterPayConfig: (id) => post(`/api/hjx/orderAfterPayConfig/${id}/enable`),
  // 关闭后付费订单设置
  closeOrderAfterPayConfig: (id) => post(`/api/hjx/orderAfterPayConfig/${id}/disable`),


  // 添加追差申请
  addOrderAprApply: (data) => post('/api/fanxing/orderAprApply/apply', data, { 'Content-Type': 'application/json' }),
  // 追差申请列表
  listSearchOrderAprApply: (data) => post(`/api/fanxing/orderAprApply/page`,data, { 'Content-Type': 'application/json' }),
  // 开始追差
  pushOrderAprApply: (id) => post(`/api/fanxing/orderAprApply/${id}/push`),
  // 取消追差
  cancelOrderAprApply: (id) => post(`/api/fanxing/orderAprApply/${id}/reset`),
   // 获取追差详情
   getOrderAprApply: (id) => post(`/api/fanxing/orderAprApply/${id}`),
     // 添加追差申请
   updateOrderAprApply: (data) => post('/api/fanxing/orderAprApply/update', data, { 'Content-Type': 'application/json' }),


// 忽略新属性值
  ignoreNewAttrMapping: (data) => post('/api/hjx/toBeAttrMapping/ignore', data, { 'Content-Type': 'application/json' }),
  // 绑定新属性值
  bindNewAttrMapping: (data) => post('/api/hjx/toBeAttrMapping/bind', data, { 'Content-Type': 'application/json' }),
  // 待绑定新属性列表
  listSearchToBeAttrMapping: (data) => post(`/api/hjx/toBeAttrMapping/page`,data, { 'Content-Type': 'application/json' }),
  

  // 根据品牌id查询机型情
  getModelListByBrandIds: (data) => post(`/api/hjx/sku/modelListByBrandIds`,data, { 'Content-Type': 'application/json' }),
  
  // 查询迪信通资产明细
  listSearchExpressFundDetail: (data) => post(`/api/hjx/dxtExpressFundDetail/page`,data, { 'Content-Type': 'application/json' }),
  
  // 导出迪信通资产明细
  exportExpressFundDetail: (data) => post(`/api/hjx/dxtExpressFundDetail/export`,data, { 'Content-Type': 'application/json' }),
  
  //导出付款记录
  exportPayOrderExport: (data) => post('/api/hjx/payOrder/findAll', data, { 'Content-Type': 'application/json' }),


   // 退款记录
   listSearchRefundOrder: (data) => post(`/api/hjx/refundOrder/page`,data, { 'Content-Type': 'application/json' }),
   // 推送订单
   pushRefundOrder: (id) => post(`/api/hjx/refundOrder/${id}/push`),
   //导出退款记录
   exportRefundOrderExport: (data) => post('/api/hjx/refundOrder/findAll', data, { 'Content-Type': 'application/json' }),

   //管理后台订单的详情
   getAdminOrderDetail:(data) => get('/api/hjx/order/admin/' + data.orderNo , data),

   // 获取历史订单列表
   getOrderHistoryList: (data) => get('/api/hjx/orderHistory', data),

   //管理后台订单的详情
   getAdminOrderHistoryDetail:(data) => post('/api/hjx/orderHistory/detail', data, { 'Content-Type': 'application/json' }),

    // 添加报价员派单规则
  addQuoteDispatchFilterConfig: (data) => post('/api/hjx/quoteDispatchFilterConfig/add', data,{ 'Content-Type': 'application/json' }),
  // 修改报价员派单规则
  updateQuoteDispatchFilterConfig: (data) => post('/api/hjx/quoteDispatchFilterConfig/update', data, { 'Content-Type': 'application/json' }),
  // 获取报价员派单规则
  getQuoteDispatchFilterConfig: (id) => get(`/api/hjx/quoteDispatchFilterConfig/${id}`),
  // 报价员派单规则list
  listSearchQuoteDispatchFilterConfig: (data) => post(`/api/hjx/quoteDispatchFilterConfig/page`,data, { 'Content-Type': 'application/json' }),
  // 删除报价员派单规则
  deleteQuoteDispatchFilterConfig: (data) => post('/api/hjx/quoteDispatchFilterConfig/delete',data),
  // 开启报价员派单规则
  openQuoteDispatchFilterConfig: (id) => post(`/api/hjx/quoteDispatchFilterConfig/${id}/enable`),
  // 关闭报价员派单规则
  closeQuoteDispatchFilterConfig: (id) => post(`/api/hjx/quoteDispatchFilterConfig/${id}/disable`),


     // 添加报价员等级限制
     addQuoterLimitPriceConfig: (data) => post('/api/hjx/quoterLimitPriceConfig/add', data,{ 'Content-Type': 'application/json' }),
     // 修改报价员等级限制
     updateQuoterLimitPriceConfig: (data) => post('/api/hjx/quoterLimitPriceConfig/update', data, { 'Content-Type': 'application/json' }),
     // 获取报价员等级限制
     getQuoterLimitPriceConfig: (id) => get(`/api/hjx/quoterLimitPriceConfig/${id}`),
     // 报价员等级限制规则list
     listSearchQuoterLimitPriceConfig: (data) => post(`/api/hjx/quoterLimitPriceConfig/page`,data, { 'Content-Type': 'application/json' }),
     // 删除报价员等级限制
     deleteQuoterLimitPriceConfig: (data) => post('/api/hjx/quoterLimitPriceConfig/delete',data),
     // 开启报价员等级限制
     openQuoterLimitPriceConfig: (id) => post(`/api/hjx/quoterLimitPriceConfig/${id}/enable`),
     // 关闭报价员等级限制
     closeQuoterLimitPriceConfig: (id) => post(`/api/hjx/quoterLimitPriceConfig/${id}/disable`),
   

    // 添加回收商派单过滤
    addRecyclerDispatchFilterConfig: (data) => post('/api/hjx/recyclerDispatchFilterConfig/add', data,{ 'Content-Type': 'application/json' }),
    // 修改回收商派单过滤
    updateRecyclerDispatchFilterConfig: (data) => post('/api/hjx/recyclerDispatchFilterConfig/update', data, { 'Content-Type': 'application/json' }),
    // 获取回收商派单过滤
    getRecyclerDispatchFilterConfig: (id) => get(`/api/hjx/recyclerDispatchFilterConfig/${id}`),
    // 回收商派单过滤list
    listSearchRecyclerDispatchFilterConfig: (data) => post(`/api/hjx/recyclerDispatchFilterConfig/page`,data, { 'Content-Type': 'application/json' }),
    // 删除回收商派单过滤
    deleteRecyclerDispatchFilterConfig: (data) => post('/api/hjx/recyclerDispatchFilterConfig/delete',data),
    // 开启回收商派单过滤
    openRecyclerDispatchFilterConfig: (id) => post(`/api/hjx/recyclerDispatchFilterConfig/${id}/enable`),
    // 关闭回收商派单过滤
    closeRecyclerDispatchFilterConfig: (id) => post(`/api/hjx/recyclerDispatchFilterConfig/${id}/disable`),


    // 获取默认报价员
    getDefaultServiceQuoterList: (id) => get(`/api/hjx/serviceProvider/listQuote/${id}`),

     // 恢复订单
     resetOrderToCurrent: (data) => post('/api/hjx/order/resetOrderToCurrent', data,{ 'Content-Type': 'application/json' }),
   
     getListSkuByModelIds: (data) => post('/api/hjx/sku/getListByModelIds', data),

    // 删除订单备注匹配项
    deleteOrderRemarkMatch: (data) => post('/api/hjx/orderRemarkMatch/delete', data, { 'Content-Type': 'application/json' }),
    // 保存新属性值
    saveOrderRemarkMatch: (data) => post('/api/hjx/orderRemarkMatch/save', data, { 'Content-Type': 'application/json' }),
    // 待绑定新属性列表
    listSearchOrderRemarkMatch: (data) => post(`/api/hjx/orderRemarkMatch/page`,data, { 'Content-Type': 'application/json' }),


    // 支付列表
    listSearchPayDetail: (data) => post(`/api/hjx/orderPayDetail/page`,data, { 'Content-Type': 'application/json' }),

    // 退款列表
    listSearchRefundDetail: (data) => post(`/api/hjx/orderRefundDetail/page`,data, { 'Content-Type': 'application/json' }),

    //导出支付记录
   exportPayDetailExport: (data) => post('/api/hjx/orderPayDetail/findAll', data, { 'Content-Type': 'application/json' }),


   //导出退款记录
   exportRefundDetailExport: (data) => post('/api/hjx/orderRefundDetail/findAll', data, { 'Content-Type': 'application/json' }),


   // 功能问题配置列表
  listSearchFunctionQuestionConfig: (data) => post(`/api/hjx/orderFunctionQuestionConfig/page`,data, { 'Content-Type': 'application/json' }),
  
   // 保存功能问题配置
   saveSearchFunctionQuestionConfig: (data) => post(`/api/hjx/orderFunctionQuestionConfig/save`,data, { 'Content-Type': 'application/json' }),
  
  // 删除功能问题配置
  deleteSearchFunctionQuestionConfig: (data) => post(`/api/hjx/orderFunctionQuestionConfig/delete`,data),

    // 开启自动出价
    openFunctionQuestionConfig: (id) => post(`/api/hjx/orderFunctionQuestionConfig/${id}/enable`),
    // 关闭自动出价
    closeFunctionQuestionConfig: (id) => post(`/api/hjx/orderFunctionQuestionConfig/${id}/disable`),
  // 修改自动出价等级规则
   updateFunctionQuestionConfig: (data) => post('/api/hjx/orderFunctionQuestionConfig/update', data, { 'Content-Type': 'application/json' }),

  // 属性Id列表
  listSearchAttrMapping: (data) => post(`/api/hjx/attrMapping/page`,data, { 'Content-Type': 'application/json' }),
  
  // 属性名称列表
  listSearchAttrNameMapping: (data) => post(`/api/hjx/thirdAttrNameMapping/page`,data, { 'Content-Type': 'application/json' }),
  
   // 机型列表
   listSearchModelMapping: (data) => post(`/api/hjx/modelMapping/page`,data, { 'Content-Type': 'application/json' }),
  
  // 删除机型映射
  deleteModelMapping: (id) => post(`/api/hjx/modelMapping/${id}`),

    //添加机型映射
  addModelMapping: (data) => post(`/api/hjx/modelMapping`,data, { 'Content-Type': 'application/json' }),
  
  
  // 删除属性ID映射
  deleteAttrMapping: (id) => post(`/api/hjx/attrMapping/${id}`),
  
  // 删除属性名称映射
  deleteAttrNameMapping: (id) => post(`/api/hjx/thirdAttrNameMapping/${id}`),

  //iemi管理
  listSearchImeiSet: (data) => post(`/api/hjx/tailiImeiSet/page`,data, { 'Content-Type': 'application/json' }),

  // 添加IMEI
  addImeiSet: (data) => post(`/api/hjx/tailiImeiSet/add`,data, { 'Content-Type': 'application/json' }),

  // 更新IMEI
  updateImeiSet: (data) => post(`/api/hjx/tailiImeiSet/update`,data, { 'Content-Type': 'application/json' }),

    // 删除IMEI
    deleteImeiSet: (data) => post(`/api/hjx/tailiImeiSet/delete`,data),

        // 删除IMEI
    deleteByIds: (data) => post(`/api/hjx/tailiImeiSet/deleteByIds`,data, { 'Content-Type': 'application/json' }),


    //导入imei
    importImei: (data) => post('/api/hjx/tailiImeiSet/importImei', data, { 'Content-Type': 'multipart/form-data' }),

  // 回收宝出价列表
  listSearchHsbQuotePriceInfo: (data) => post(`/api/hjx/hsbQuotePriceInfo/page`,data, { 'Content-Type': 'application/json' }),

   //导出回收宝出价列表
   exportHsbQuotePriceInfo: (data) => post('/api/hjx/hsbQuotePriceInfo/findAll', data, { 'Content-Type': 'application/json' }),

    // 手动变更为支付成功
    privatePaySuccess: (id) => post(`/api/hjx/orderPayDetail/${id}/paySuccess`),

    // 重置支付
    privateClerkResetPay: (id) => post(`/api/hjx/orderPayDetail/${id}/clerkResetPay`),

    //退款重置
    privatePayResetRefund: (id) => post(`/api/hjx/orderRefundDetail/${id}/resetRefund`),

    // 回收出价白名单列表
    listHsbQuoteWhiteSearch: (data) => post('/api/hjx/hsbQuoteWhiteList/listSearch', data),

   //添加回收出价白名单
    addHsbQuoteWhite: (data) => post('/api/hjx/hsbQuoteWhiteList/add', data),

     //删除回收出价白名单
    deleteHsbQuoteWhite: (data) => post('/api/hjx/hsbQuoteWhiteList/delete', data),

      // 获取报价记录订单列表
   getQuoterOrderInfoPage: (data) => get('/api/hjx/orderQuoteRecord', data),

    // 查询支付凭证
    queryPayReceipt: (orderNo) => post(`/api/open/sh/payImageUrl/${orderNo}`),

     // 添加自动出价等级规则
    addAutoPriceImageDetectConfig: (data) => post('/api/hjx/autoPriceImageDetectConfig/add', data,{ 'Content-Type': 'application/json' }),
    // 修改自动出价等级规则
    updateAutoPriceImageDetectConfig: (data) => post('/api/hjx/autoPriceImageDetectConfig/update', data, { 'Content-Type': 'application/json' }),
    // 获取自动出价等级规则
    getAutoPriceImageDetectConfig: (id) => get(`/api/hjx/autoPriceImageDetectConfig/${id}`),
    // 自动出价等级规则list
    listSearchAutoPriceImageDetectConfig: (data) => post(`/api/hjx/autoPriceImageDetectConfig/page`,data, { 'Content-Type': 'application/json' }),
    // 删除自动出价等级规则
    deleteAutoPriceImageDetectConfig: (data) => post('/api/hjx/autoPriceImageDetectConfig/delete',data),
    // 开启自动出价
    openAutoPriceImageDetectConfig: (id) => post(`/api/hjx/autoPriceImageDetectConfig/${id}/enable`),
    // 关闭自动出价
    closeAutoPriceImageDetectConfig: (id) => post(`/api/hjx/autoPriceImageDetectConfig/${id}/disable`),

         // 添加自动出价等级规则
    addAutoPriceDeductionOption: (data) => post('/api/hjx/autoPriceDeductionOption/add', data,{ 'Content-Type': 'application/json' }),
    // 修改自动出价等级规则
    updateAutoPriceDeductionOption: (data) => post('/api/hjx/autoPriceDeductionOption/update', data, { 'Content-Type': 'application/json' }),
    // 获取自动出价等级规则
    getAutoPriceDeductionOption: (id) => get(`/api/hjx/autoPriceDeductionOption/${id}`),
    // 自动出价等级规则list
    listSearchAutoPriceDeductionOption: (data) => post(`/api/hjx/autoPriceDeductionOption/page`,data, { 'Content-Type': 'application/json' }),
    // 删除自动出价等级规则
    deleteAutoPriceDeductionOption: (data) => post('/api/hjx/autoPriceDeductionOption/delete',data),
    // 开启自动出价
    openAutoPriceDeductionOption: (id) => post(`/api/hjx/autoPriceDeductionOption/${id}/enable`),
    // 关闭自动出价
    closeAutoPriceDeductionOption: (id) => post(`/api/hjx/autoPriceDeductionOption/${id}/disable`),


    // 修改机型名称错误
    updateNotMatchModel: (data) => post('/api/hjx/orderModelNotMatchInfo/update', data, { 'Content-Type': 'application/json' }),
  
    // 机型名称错误list
    listSearchNotMatchModel: (data) => post(`/api/hjx/orderModelNotMatchInfo/page`,data, { 'Content-Type': 'application/json' }),
    
    // 删除机型名称错误
    deleteNotMatchModel: (data) => post('/api/hjx/orderModelNotMatchInfo/delete',data),

      //获取订单图片
    getImageList: (data) => post('/api/hjx/orderModelNotMatchInfo/getImageList',data),
   
   

    // 添加年代机配置
    addMachineYearConfig: (data) => post('/api/hjx/machineYearConfig/add', data,{ 'Content-Type': 'application/json' }),
    // 修改年代机配置
    updateMachineYearConfig: (data) => post('/api/hjx/machineYearConfig/update', data, { 'Content-Type': 'application/json' }),
    // 获取年代机配置
    getMachineYearConfig: (id) => get(`/api/hjx/machineYearConfig/${id}`),
    // 年代机配置list
    listSearchMachineYearConfig: (data) => post(`/api/hjx/machineYearConfig/page`,data, { 'Content-Type': 'application/json' }),
    // 删除年代机配置
    deleteMachineYearConfig: (data) => post('/api/hjx/machineYearConfig/delete',data),
     // 年代机配置list
    listMachineYearConfig: (data) => post(`/api/hjx/machineYearConfig/list`,data, { 'Content-Type': 'application/json' }),
    
        // 添加年代机配置
    addSysDict: (data) => post('/api/sys/sysDict/add', data,{ 'Content-Type': 'application/json' }),
    // 修改年代机配置
    updateSysDict: (data) => post('/api/sys/sysDict/update', data, { 'Content-Type': 'application/json' }),
    // 获取年代机配置
    getSysDict: (id) => get(`/api/sys/sysDict/${id}`),
    // 年代机配置list
    listSearchSysDict: (data) => post(`/api/sys/sysDict/page`,data, { 'Content-Type': 'application/json' }),
    // 删除年代机配置
    deleteSysDict: (data) => post('/api/sys/sysDict/delete',data),
    // 更新缓存年代机配置
    updateCacheSysDict: (data) => post('/api/sys/sysDict/updateCache',data),


    // 添加人工出价等级限制
    addManualQuoteMachineGradeLimitConfig: (data) => post('/api/hjx/manualQuoteMachineGradeLimitConfig/add', data,{ 'Content-Type': 'application/json' }),
    // 修改人工出价等级限制
    updateManualQuoteMachineGradeLimitConfig: (data) => post('/api/hjx/manualQuoteMachineGradeLimitConfig/update', data, { 'Content-Type': 'application/json' }),
    // 获取人工出价等级限制
    getManualQuoteMachineGradeLimitConfig: (id) => get(`/api/hjx/manualQuoteMachineGradeLimitConfig/${id}`),
    // 人工出价等级限制list
    listSearchManualQuoteMachineGradeLimitConfig: (data) => post(`/api/hjx/manualQuoteMachineGradeLimitConfig/page`,data, { 'Content-Type': 'application/json' }),
    // 删除人工出价等级限制
    deleteManualQuoteMachineGradeLimitConfig: (data) => post('/api/hjx/manualQuoteMachineGradeLimitConfig/delete',data),
    // 开启自动出价
    openManualQuoteMachineGradeLimitConfig: (id) => post(`/api/hjx/manualQuoteMachineGradeLimitConfig/${id}/enable`),
    // 关闭自动出价
    closeManualQuoteMachineGradeLimitConfig: (id) => post(`/api/hjx/manualQuoteMachineGradeLimitConfig/${id}/disable`),

    
    // 正在报价的人员列表
    getQuotingUserNameList: (id) => post(`/api/hjx/quoteMonitor/quotingUserNameList`),
    // 在线接单人员列表
    getReceiveOrderUserNameList: (id) => post(`/api/hjx/quoteMonitor/receiveOrderUserNameList`),
    // 待分配订单列表
    getToAllocatedOrderList: (id) => post(`/api/hjx/quoteMonitor/toAllocatedOrderList`),

     // 清理派单锁
    clearQuoteLock: (id) => post(`api/hjx/quoteMonitor/clearLock/${id}`),


     //基准定价接口
    modelPriceChangeApplyListSearch: (data) => post('/api/hjx/modelPriceChangeApply/listSearch', data),

      //基准定价接口
    modelPriceChangeApplyById: (data) => get('/api/hjx/modelPriceChangeApply/getById', data),

    updateModelPriceChangeApply: (data) => post('/api/hjx/modelPriceChangeApply/updateModelPrice', data),

    imporModelPriceChangeApplyTemplete: (data) => post('/api/hjx/modelPriceChangeApply/imporModelPriceTemplete', data, { 'Content-Type': 'multipart/form-data' }),
    //基准定价接口
    modelPriceHistoryListSearch: (data) => post('/api/hjx/modelPriceHistory/listSearch', data),

    batchCheckPassModelPriceChangeApply: (data) => post('/api/hjx/modelPriceChangeApply/batchCheckPass', data),
    //删除基准定价
    deleteModelPriceChangeApply: (data) => post('/api/hjx/modelPriceChangeApply/delete', data),

     //校验变更价格对应的sku是否存在价格倒挂
    checkModelPriceChangeApplyAllPrice: (data) => post('/api/hjx/modelPriceChangeApply/checkAllPrice', data),

         //校验变更价格对应的sku是否存在价格倒挂
    checkModelPriceChangeApplyPrice: (data) => post('/api/hjx/modelPriceChangeApply/checkPrice', data),

      //校验变更价格对应的sku是否存在价格倒挂
    checkModelPriceChangePrice: (data) => post('/api/hjx/modelPrice/checkPrice', data),

    // 添加支付配置规则
   addSecretManage: (data) => post('/api/hjx/recyclerSecretManage/add', data,{ 'Content-Type': 'application/json' }),
   // 修改支付配置规则
   updateSecretManage: (data) => post('/api/hjx/recyclerSecretManage/update', data, { 'Content-Type': 'application/json' }),
   // 获取支付配置规则
   getSecretManage: (id) => get(`/api/hjx/recyclerSecretManage/${id}`),
   // 支付配置规则list
   listSearchSecretManage: (data) => post(`/api/hjx/recyclerSecretManage/page`,data, { 'Content-Type': 'application/json' }),
   // 删除支付配置规则
   deleteSecretManage: (data) => post('/api/hjx/recyclerSecretManage/delete',data),
     // 开启支付配置
   openSecretManage: (id) => post(`/api/hjx/recyclerSecretManage/${id}/enable`),
     // 关闭支付配置
   closeSecretManage: (id) => post(`/api/hjx/recyclerSecretManage/${id}/disable`),

     // 添加支付配置规则
   addRecyclerAddress: (data) => post('/api/hjx/recyclerAddress/add', data,{ 'Content-Type': 'application/json' }),
   // 修改支付配置规则
   updateRecyclerAddress: (data) => post('/api/hjx/recyclerAddress/update', data, { 'Content-Type': 'application/json' }),
   // 获取支付配置规则
   getRecyclerAddress: (serviceId) => get(`/api/hjx/recyclerAddress/${serviceId}`),
   // 支付配置规则list
   listSearchRecyclerAddress: (data) => post(`/api/hjx/recyclerAddress/page`,data, { 'Content-Type': 'application/json' }),
   // 删除支付配置规则
   deleteRecyclerAddress: (data) => post('/api/hjx/recyclerAddress/delete',data),
    
    
    // 回收商统计导出
  // getOrderServiceStatExport: (data) => {
  //   let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''
  //   return axios({
  //     url: prefix+"/api/hjx/dataStat/orderServiceStatExport",
  //     method: "get",
  //     params: data,
  //     responseType: "blob"
  //   });
  // }
}